import { render, staticRenderFns } from "./BaseItemForm.vue?vue&type=template&id=011b3849"
import script from "./BaseItemForm.vue?vue&type=script&lang=js"
export * from "./BaseItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports